<section appTitle pageTitle="Profile">
	<app-profile-details></app-profile-details>
	<app-password-reset></app-password-reset>
</section>
